// Country list for the request form. Україна first, then rest alphabetically (UK alphabet).
export const COUNTRIES = [
  { en: "Ukraine", uk: "Україна" },
  { en: "Austria", uk: "Австрія" },
  { en: "Albania", uk: "Албанія" },
  { en: "Andorra", uk: "Андорра" },
  { en: "Belgium", uk: "Бельгія" },
  { en: "Bulgaria", uk: "Болгарія" },
  { en: "Bosnia and Herzegovina", uk: "Боснія і Герцеговина" },
  { en: "United Kingdom", uk: "Велика Британія" },
  { en: "Greece", uk: "Греція" },
  { en: "Denmark", uk: "Данія" },
  { en: "Estonia", uk: "Естонія" },
  { en: "Ireland", uk: "Ірландія" },
  { en: "Iceland", uk: "Ісландія" },
  { en: "Spain", uk: "Іспанія" },
  { en: "Italy", uk: "Італія" },
  { en: "Cyprus", uk: "Кіпр" },
  { en: "Kosovo", uk: "Косово" },
  { en: "Latvia", uk: "Латвія" },
  { en: "Lithuania", uk: "Литва" },
  { en: "Liechtenstein", uk: "Ліхтенштейн" },
  { en: "Luxembourg", uk: "Люксембург" },
  { en: "Malta", uk: "Мальта" },
  { en: "Moldova", uk: "Молдова" },
  { en: "Monaco", uk: "Монако" },
  { en: "Netherlands", uk: "Нідерланди" },
  { en: "Germany", uk: "Німеччина" },
  { en: "Norway", uk: "Норвегія" },
  { en: "North Macedonia", uk: "Північна Македонія" },
  { en: "Poland", uk: "Польща" },
  { en: "Portugal", uk: "Португалія" },
  { en: "Romania", uk: "Румунія" },
  { en: "San Marino", uk: "Сан-Марино" },
  { en: "Serbia", uk: "Сербія" },
  { en: "Slovakia", uk: "Словаччина" },
  { en: "Slovenia", uk: "Словенія" },
  { en: "Hungary", uk: "Угорщина" },
  { en: "Finland", uk: "Фінляндія" },
  { en: "France", uk: "Франція" },
  { en: "Croatia", uk: "Хорватія" },
  { en: "Czech Republic", uk: "Чехія" },
  { en: "Montenegro", uk: "Чорногорія" },
  { en: "Switzerland", uk: "Швейцарія" },
  { en: "Sweden", uk: "Швеція" },
];

export const translations = {
  en: {
    nav: {
      about: "About",
      services: "Services",
      cases: "Industries we staff",
      contact: "Contact",
      cta: "Get a quote",
    },
    contactManager: {
      online: "Online",
      text: "Message our manager on Telegram right now",
      ariaLabel: "Message our manager on Telegram",
    },
    hero: {
      label: "International workforce",
      title1: "Workers without borders.",
      title2: "Scale production without limits.",
      sub: "We bring verified international workers to manufacturers in Europe — turnkey, fully legal, with zero HR, tax or migration risk.",
      cta: "Get your workforce quote",
      ctaSecondary: "Industries we staff",
      trust: "Trusted by European manufacturers across Central and Eastern Europe",
      trustLabel: "Trusted by",
    },
    about: {
      label: "Who we are",
      title: "Built to lift the workforce ceiling on your business.",
      body: "Kadra Talent is a full-cycle international recruitment and legal employment agency. We close the labour shortage on production floors across Europe by bringing verified workers from abroad — and we handle the entire journey, from sourcing in the candidate's home country to full legalization and employment. We hire for reliability, not just paperwork: a worker may lack formal credentials, but every candidate is screened and verified by us as dependable.",
      stats: [
        { value: "10+", label: "Years of lead expertise" },
        { value: "9", label: "Source countries" },
        { value: "2", label: "Engagement models" },
        { value: "0%", label: "HR / tax / migration risk" },
      ],
      whereWeOperate: {
        label: "Where we operate",
        body: "Central and Eastern Europe — Poland, Czechia, Slovakia, Romania, Hungary, Lithuania, Latvia, Estonia, Bulgaria, Croatia and Slovenia.",
      },
    },
    services: {
      label: "What we do",
      title: "Two models. One turnkey service.",
      ctaQuote: "Get a quote",
      processNote: "Typical launch: 3–6 months.",
      items: [
        {
          key: "outsourcing",
          title: "Personnel outsourcing",
          tagline: "We deliver — you employ.",
          body: "We handle the whole process of finding, bringing and legalizing the candidate. Then you take the person onto your own payroll and pay their salary, taxes and contributions yourself. We do the sourcing and delivery; employment and upkeep are on your side.",
          timeline: [
            {
              title: "Recruitment & screening",
              body: "Sourcing, screening and selection in the home country.",
            },
            {
              title: "Visa support",
              body: "Documentation and consular support in the country of origin.",
            },
            {
              title: "Transit legalization",
              body: "Transit visas and government-portal filing.",
            },
            {
              title: "Full legalization",
              body: "Residence permit, registration, state fees, insurance & onboarding.",
            },
          ],
        },
        {
          key: "outstaffing",
          title: "Personnel outstaffing",
          tagline: "Worker on our payroll — zero liability for you.",
          body: "The worker stays on Kadra Talent's payroll, not yours. You don't put the person on your books, don't pay their taxes or contributions, and don't handle HR — we do all of it. We source, bring, legalize and support the worker and act as their official employer. You simply get the work done and pay one service fee.",
          timeline: [
            {
              title: "Launch",
              body: "International recruitment, legal compliance, legalization & cross-border logistics.",
            },
            {
              title: "Onboarding",
              body: "Employment under the operator as the official employer.",
            },
            {
              title: "Monthly maintenance",
              body: "Payroll with all employer taxes + a fixed service component.",
            },
            {
              title: "Ongoing HR & accounting",
              body: "Full records, with free worker rotation in the first 3 months.",
            },
          ],
        },
      ],
    },
    industries: {
      label: "Industries we staff",
      title: "Who we can bring you workers for",
      items: [
        {
          title: "Manufacturing & metalworking",
          body: "Fitters, machine operators, welders and production-line workers.",
        },
        {
          title: "Agriculture",
          body: "Field, greenhouse and harvest workers, farm and livestock staff.",
        },
        {
          title: "Construction",
          body: "General labourers, finishers, concrete and assembly crews.",
        },
        {
          title: "Logistics & warehousing",
          body: "Warehouse operatives, pickers, loaders and forklift operators.",
        },
        {
          title: "Food processing",
          body: "Production and packing-line staff, sorters and processing operatives.",
        },
        {
          title: "Hospitality / HoReCa",
          body: "Kitchen, cleaning, housekeeping and back-of-house staff.",
        },
      ],
    },
    faq: {
      label: "FAQ",
      title: "Answers to the questions buyers ask first.",
      items: [
        {
          q: "What is the difference between personnel outsourcing and personnel outstaffing at Kadra Talent?",
          a: "Personnel outsourcing: we find, bring and legalize the candidate, then YOU take them onto your own payroll and pay their salary and taxes yourself. Personnel outstaffing: the worker stays on Kadra Talent's payroll as our employee — you don't put the person on your books, don't pay their taxes and don't run HR for them. Both models are end-to-end.",
        },
        {
          q: "Which countries do you operate in?",
          a: "We operate across Central and Eastern Europe — Poland, Czechia, Slovakia, Romania, Hungary, Lithuania, Latvia, Estonia, Bulgaria, Croatia and Slovenia.",
        },
        {
          q: "From which countries do you bring workers?",
          a: "We operate across nine active source countries in Central and South Asia, Africa, South and Southeast Asia. Every candidate is screened and verified by us for reliability.",
        },
        {
          q: "How long does an end-to-end launch take?",
          a: "Typical end-to-end launch is 3 to 6 months — from brief, recruitment and verification, through visa support and transit legalization, to full legalization and on-site onboarding.",
        },
        {
          q: "Which industries does Kadra Talent staff?",
          a: "Manufacturing and metalworking, agriculture, construction, logistics and warehousing, food processing, and hospitality / HoReCa. We supply fitters, machine operators, welders, line workers, warehouse operatives, forklift operators, finishers, kitchen and housekeeping staff, and more.",
        },
        {
          q: "How do I get a workforce quote?",
          a: "Submit the request form on this page or write to info@kadratalent.com. We respond within 1–2 business days with a tailored quote, no commitment required at this stage.",
        },
      ],
    },
    form: {
      label: "Contact",
      title:
        "Tell us what you need — we'll quote within 1–2 business days.",
      fields: {
        company: "Company name",
        country: "Country of operation",
        workers: "Number of workers required",
        industry: "Industry",
        jobType: "Job type / specialty",
        phone: "Phone number",
        name: "Your name",
        email: "E-mail address",
        contactMethod: "Preferred contact method",
      },
      methods: [
        { key: "whatsapp", label: "WhatsApp" },
        { key: "meeting", label: "Book a meeting" },
      ],
      pickATime: "Pick a time",
      bookingUrl: "https://calendly.com/kadratalent/intro",
      thankYou: {
        title: "Request received.",
        body: "Our team will be in touch within 1–2 business days.",
        whatsappCta: "Open WhatsApp group",
        whatsappNote: "Join our WhatsApp channel for an instant reply:",
        meetingTitle: "One last step — pick a time.",
        meetingBody: "Choose a slot below and we'll send a calendar invite to your e-mail.",
        sendAnother: "Send another request",
      },
      modal: {
        title: "Book a meeting",
        close: "Close",
        loading: "Loading the scheduler…",
        booked: "Meeting booked. We'll see you then.",
      },
      submitError: "Couldn't send your request. Please check your connection and try again.",
      submit: "Submit request",
      note: "We respond within 1–2 business days. No commitment required at this stage.",
      success:
        "Request received. Our team will be in touch within 1–2 business days.",
      gdpr: "GDPR · EU 2016/679",
      contactEmail: "info@kadratalent.com",
    },
    footer: {
      tagline:
        "Workers without borders. Scale production without limits.",
      navLabel: "Navigation",
      contactLabel: "Contact",
      nav: ["About", "Services", "Industries we staff", "Contact"],
      legal:
        "© 2025 Kadra Talent. All rights reserved. Personal data processed in accordance with GDPR (EU 2016/679). Registered international recruitment intermediary.",
      domain: "kadratalent.com",
      contact: "info@kadratalent.com",
      madeIn: "Made in Europe",
    },
  },
  uk: {
    nav: {
      about: "Про нас",
      services: "Послуги",
      cases: "Галузі, які ми закриваємо",
      contact: "Контакти",
      cta: "Отримати прорахунок",
    },
    contactManager: {
      online: "На зв'язку",
      text: "Написати менеджеру в Telegram прямо зараз",
      ariaLabel: "Написати менеджеру в Telegram",
    },
    hero: {
      label: "Міжнародний персонал",
      title1: "Робітники без кордонів.",
      title2: "Масштабування виробництва без обмежень.",
      sub: "Привозимо перевірений іноземний персонал на виробництва в Україні та Європі — під ключ, повністю легально, без кадрових, податкових і міграційних ризиків.",
      cta: "Отримати прорахунок",
      ctaSecondary: "Галузі, які ми закриваємо",
      trust: "Нам довіряють виробники в Україні та ЄС",
      trustLabel: "Довіра",
    },
    about: {
      label: "Хто ми",
      title: "Створені, щоб зняти кадрову стелю вашого бізнесу.",
      body: "Kadra Talent — агенція повного циклу з міжнародного рекрутингу та легального працевлаштування. Ми закриваємо дефіцит робочих рук на виробництвах, привозячи перевірений персонал з-за кордону, і беремо на себе весь шлях — від пошуку в країні проживання до повної легалізації та працевлаштування. Ми ставимо в основу надійність, а не «папірець»: працівник може не мати формальної кваліфікації, але кожен кандидат перевірений і верифікований нами як надійний.",
      stats: [
        { value: "10+", label: "Років досвіду куратора" },
        { value: "9", label: "Країн походження" },
        { value: "2", label: "Моделі співпраці" },
        { value: "0%", label: "Кадрових і податкових ризиків" },
      ],
    },
    services: {
      label: "Що ми робимо",
      title: "Дві моделі. Один сервіс під ключ.",
      ctaQuote: "Отримати прорахунок",
      processNote: "Орієнтовний запуск: 3–6 місяців.",
      items: [
        {
          key: "outsourcing",
          title: "Аутсорсинг персоналу",
          tagline: "Ми привозимо — ви берете в штат.",
          body: "Ми беремо на себе весь процес пошуку, привозу й легалізації кандидата. Далі ви берете цю людину до себе у штат (на баланс) і самі платите їй зарплату, податки та внески. Тобто підбір і доставку робимо ми — а працевлаштування й утримання вже на вашому боці.",
          timeline: [
            {
              title: "Рекрутинг і скринінг",
              body: "Пошук, скринінг і підбір у країні проживання.",
            },
            {
              title: "Візовий супровід",
              body: "Документи та консульський супровід у країні походження.",
            },
            {
              title: "Транзитна легалізація",
              body: "Транзитні візи та подача через урядовий портал.",
            },
            {
              title: "Повна легалізація",
              body: "Посвідка на проживання, реєстрація, держзбори, страхування й вихід на роботу.",
            },
          ],
        },
        {
          key: "outstaffing",
          title: "Аутстафінг персоналу",
          tagline: "Працівник у нашому штаті — ви ні за що не відповідаєте.",
          body: "Працівник лишається у штаті Kadra Talent, а не у вас. Ви не берете людину на баланс, не платите за неї податки й внески, не ведете кадровий облік — усе це робимо ми. Ми знаходимо, привозимо, легалізуємо й супроводжуємо працівника та виступаємо його офіційним роботодавцем. Ви просто отримуєте роботу й оплачуєте одну послугу.",
          timeline: [
            {
              title: "Запуск",
              body: "Міжнародний рекрутинг, юридичний комплаєнс, легалізація та транскордонна логістика.",
            },
            {
              title: "Оформлення під оператором",
              body: "Працевлаштування під оператором як офіційним роботодавцем.",
            },
            {
              title: "Щомісячне утримання",
              body: "Фонд оплати праці з усіма податками роботодавця + фіксований сервісний компонент.",
            },
            {
              title: "Постійні кадри й бухгалтерія",
              body: "Повне ведення обліку, з безкоштовною ротацією працівника в перші 3 місяці.",
            },
          ],
        },
      ],
    },
    industries: {
      label: "Галузі, які ми закриваємо",
      title: "Для кого ми знаходимо персонал",
      items: [
        {
          title: "Виробництво та металообробка",
          body: "Слюсарі, оператори станків, зварювальники та робітники виробничих ліній.",
        },
        {
          title: "Сільське господарство",
          body: "Польові, тепличні та збиральні робітники, персонал ферм і тваринництва.",
        },
        {
          title: "Будівництво",
          body: "Різнороби, оздоблювальники, бетонні та монтажні бригади.",
        },
        {
          title: "Логістика та склади",
          body: "Складські працівники, комплектувальники, вантажники та оператори навантажувачів.",
        },
        {
          title: "Харчова промисловість",
          body: "Працівники виробничих і пакувальних ліній, сортувальники, оператори переробки.",
        },
        {
          title: "Готельно-ресторанний сектор",
          body: "Кухонний, прибиральний та допоміжний персонал готелів і ресторанів.",
        },
      ],
    },
    faq: {
      label: "Питання та відповіді",
      title: "Відповіді на запитання, які ставлять першими.",
      items: [
        {
          q: "У чому різниця між аутсорсингом і аутстафінгом персоналу у Kadra Talent?",
          a: "Аутсорсинг персоналу: ми знаходимо, привозимо й легалізуємо кандидата, далі ВИ берете людину собі у штат і самі платите їй зарплату, податки та внески. Аутстафінг персоналу: працівник лишається у штаті Kadra Talent як наш співробітник — ви не берете людину на баланс, не платите за неї податки й не ведете кадровий облік. Обидві моделі — від брифу до виходу на роботу.",
        },
        {
          q: "З яких країн ви привозите працівників?",
          a: "Ми працюємо з дев'ятьма активними країнами походження — Центральна та Південна Азія, Африка, Південна та Південно-Східна Азія, Східна Європа. Кожен кандидат перевірений і верифікований нами як надійний.",
        },
        {
          q: "Скільки триває запуск під ключ?",
          a: "Орієнтовний запуск — 3–6 місяців: від брифу та рекрутингу до візового супроводу, транзитної та повної легалізації, виходу на роботу й супроводу.",
        },
        {
          q: "Які галузі ви закриваєте?",
          a: "Виробництво та металообробка, сільське господарство, будівництво, логістика та склади, харчова промисловість, готельно-ресторанний сектор. Слюсарі, оператори станків, зварювальники, лінійні працівники, складські, оператори навантажувачів, оздоблювальники, кухонний і прибиральний персонал та інші.",
        },
        {
          q: "Як отримати прорахунок?",
          a: "Заповніть форму на цій сторінці або напишіть на info@kadratalent.com. Відповідаємо протягом 1–2 робочих днів. На цьому етапі — без зобов'язань.",
        },
      ],
    },
    form: {
      label: "Контакти",
      title: "Опишіть потребу — прорахуємо за 1–2 робочі дні.",
      fields: {
        company: "Назва компанії",
        country: "Країна діяльності",
        workers: "Потрібна кількість працівників",
        industry: "Галузь",
        jobType: "Тип роботи / спеціальність",
        phone: "Номер телефону",
        name: "Ваше ім'я",
        email: "E-mail",
        contactMethod: "Зручний спосіб зв'язку",
      },
      methods: [
        { key: "whatsapp", label: "WhatsApp" },
        { key: "meeting", label: "Забронювати зустріч" },
      ],
      pickATime: "Обрати час",
      bookingUrl: "https://calendly.com/kadratalent/intro",
      thankYou: {
        title: "Запит отримано.",
        body: "Команда зв'яжеться з вами протягом 1–2 робочих днів.",
        whatsappCta: "Відкрити WhatsApp",
        whatsappNote: "Приєднайтесь до нашого WhatsApp-каналу для миттєвої відповіді:",
        meetingTitle: "Останній крок — оберіть час.",
        meetingBody: "Виберіть зручний слот нижче — ми надішлемо запрошення в календар на ваш e-mail.",
        sendAnother: "Надіслати ще запит",
      },
      modal: {
        title: "Бронювання зустрічі",
        close: "Закрити",
        loading: "Завантажуємо календар…",
        booked: "Зустріч заброньовано. До зустрічі.",
      },
      submitError: "Не вдалося надіслати запит. Перевірте з'єднання та спробуйте ще раз.",
      submit: "Надіслати запит",
      note: "Відповідаємо протягом 1–2 робочих днів. На цьому етапі — без зобов'язань.",
      success:
        "Запит отримано. Команда зв'яжеться з вами протягом 1–2 робочих днів.",
      gdpr: "GDPR · ЄС 2016/679",
      contactEmail: "info@kadratalent.com",
    },
    footer: {
      tagline:
        "Робітники без кордонів. Масштабування виробництва без обмежень.",
      navLabel: "Навігація",
      contactLabel: "Контакти",
      nav: ["Про нас", "Послуги", "Галузі, які ми закриваємо", "Контакти"],
      legal:
        "© 2025 Kadra Talent. Усі права захищено. Персональні дані обробляються відповідно до GDPR (ЄС 2016/679). Зареєстрований посередник з міжнародного рекрутингу.",
      domain: "kadratalent.com",
      contact: "info@kadratalent.com",
      madeIn: "Зроблено в Європі",
    },
  },
};
